import React from 'react'
import qs from 'qs'
import moment from 'moment'

class Utils {

    static urlWithParameters(url: string, query: Record<string, unknown> | null | undefined, params?: Record<string, unknown> | null, keysToDelete: string[] = []): string {
        let searchParams: Record<string, unknown> = { ...(query || {}), ...(params || {}) }
        keysToDelete.forEach(k => {
            delete searchParams[k]
        })
        const searchString = qs.stringify(searchParams)
        const separator = searchString.length > 0 ? "?" : ""
        return url + separator + searchString
    }

    static currentUrlWithParams(params: Record<string, unknown>, keysToDelete: string[] = []): string {
        const searchParams = qs.parse(window.location.search.substr(1))
        const url = window.location.origin + window.location.pathname
        return this.urlWithParameters(url, searchParams as Record<string, unknown>, params, keysToDelete) + window.location.hash
    }

    static pushUrlWithParams(params: Record<string, unknown>, keysToDelete: string[] = []): void {
        const url = this.currentUrlWithParams(params, keysToDelete)
        if (url !== (window.location as unknown as string)) {
            window.history.pushState(null, '', url)
        }
    }

    static formatMoney(amount: number | string, color: true): React.ReactElement
    static formatMoney(amount: number | string, color?: false): string
    static formatMoney(amount: number | string, color: boolean = false): string | React.ReactElement {
        const str = parseFloat(String(amount)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        if (color) {
            if (Number(amount) < 0) {
                return <span className="money-negative">{str}</span>
            } else {
                return <span className="money-positive">{str}</span>
            }
        } else {
            return str
        }
    }

    static formatPreciseAmount(amount: number | string, color: boolean = false): string | React.ReactElement {
        const str = parseFloat(String(amount)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })
        if (color) {
            if (Number(amount) < 0) {
                return <span className="money-negative">{str}</span>
            } else {
                return <span className="money-positive">{str}</span>
            }
        } else {
            return str
        }
    }

    static formatDate(date: Date | string): string {
        return moment(date).format("YYYY-MM-DD")
    }
}

export default Utils
